<template>
    <div>
        <switch-type></switch-type>
        <benefit></benefit>
        <strengths></strengths>
        <new-article></new-article>
    </div>
</template>
<script>
import switchType from '@/components/officailPage/home/switchType.vue';
import benefit from '@/components/officailPage/home/benefit.vue';
import strengths from '@/components/officailPage/home/strengths.vue';
import newArticle from '@/components/officailPage/home/article.vue';

export default {
    components: {
        switchType,
        benefit,
        strengths,
        newArticle
    }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/officailPage/home/home.vue